import { type ZoneSheet, zoneSheetText } from "../../shared/zones";

const ICON: Record<ZoneSheet["kind"], string> = {
  slow: "/icons/zone-slow-28.svg",
  noParking: "/icons/zone-noparking-28.svg",
  noRide: "/icons/zone-noriding-28.svg",
  outside: "/icons/zone-boundary-44.svg",
};

/**
 * Entering a zone during a ride (decision 14/10/2026; no Figma frame): a card on the menu row with
 * the zone's badge and its K2–K5 title and subtitle. Hides after 5 s, or on tap.
 */
export function ZoneToast(props: { zone: ZoneSheet; onClose: () => void }) {
  const text = () => zoneSheetText(props.zone);
  return (
    <button
      type="button"
      class="flex min-h-[50px] w-full items-center gap-[9px] rounded-[10px] bg-white py-[6px] pl-2 pr-3 text-left shadow-[0_2px_8px_rgba(0,0,0,0.16)]"
      role="status"
      aria-live="polite"
      onClick={props.onClose}
    >
      <span class="relative h-[34px] w-[34px] shrink-0">
        <img
          src={ICON[props.zone.kind]}
          width={props.zone.kind === "outside" ? 28 : 34}
          height={props.zone.kind === "outside" ? 28 : 34}
          alt=""
          class={props.zone.kind === "outside" ? "absolute left-[3px] top-[3px]" : ""}
        />
      </span>
      <span class="min-w-0">
        <span class="block text-sm font-medium leading-[1.25] tracking-[0.14px] text-strong">
          {text().title}
        </span>
        <span class="block text-xs leading-[1.25] tracking-[0.12px] text-text">
          {text().subtitle}
        </span>
      </span>
    </button>
  );
}
